module.exports = __webpack_public_path__ + "static/img/IMG_3267.ba002f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/news/gallery/11/IMG_3267.jpg
// module id = 670
// module chunks = 0